export default "__VITE_ASSET__CZiIeWYl__"